const MODAL_OVERLAY_SELECTOR = '[data-modal-overlay]';
const MODAL_SELECTOR = '[data-modal]';
const MODAL_CLOSE_SELECTOR = '[data-modal-close]';
const MODAL_TRIGGER_SELECTOR = '[data-modal-trigger]';
const MODAL_TITLE_SELECTOR = '[data-modal-title]';
const MODAL_BODY_SELECTOR = '[data-modal-body]';
const MODAL_ACTIVE_CLASS = 'is-active';
const MODAL_BODY_LOCK_CLASS = 'modal-open';

let modalOverlay;
let modal;
let modalTitle;
let modalBody;
let isOpen = false;
let i18n = {};

// Helper function to format price with spaces as thousands separator
function formatPrice(price) {
    if (price === null || price === undefined) return '-';
    const formatted = price.toFixed(2).replace('.', ',');
    const parts = formatted.split(',');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return integerPart + ',' + parts[1];
}

// Helper function to render a single component item
function renderComponentItem(container, component, showDividerAfter) {
    // Top divider
    const topDivider = document.createElement('div');
    topDivider.className = 'modal__divider';
    container.appendChild(topDivider);

    // Item container
    const itemContainer = document.createElement('div');
    itemContainer.className = 'modal__additional-costs-item';

    // Component name
    const nameEl = document.createElement('div');
    nameEl.className = 'modal__additional-costs-item-name';
    nameEl.textContent = component.name;
    itemContainer.appendChild(nameEl);

    // Price row
    const priceRow = document.createElement('div');
    priceRow.className = 'modal__additional-costs-item-row';

    // Price value
    const priceValue = document.createElement('span');
    priceValue.className = 'modal__additional-costs-item-price';
    priceValue.textContent = component.priceGross ? formatPrice(component.priceGross) + ' ' + (i18n.currency || 'zł') : '-';
    priceRow.appendChild(priceValue);

    // History link (if has history)
    if (component.history && component.history.length > 0) {
        const historyLink = document.createElement('a');
        historyLink.href = '#';
        historyLink.className = 'modal__additional-costs-item-history-link';
        historyLink.textContent = i18n.viewHistory || 'Zobacz historię ceny';
        historyLink.addEventListener('click', (e) => {
            e.preventDefault();
            // Open component price history modal
            openModal('component-price-history', component.history, component.name);
        });
        priceRow.appendChild(historyLink);
    }

    // Quantity info (if available and not required)
    if (component.quantity && !component.isRequired) {
        const quantityInfo = document.createElement('span');
        quantityInfo.className = 'modal__additional-costs-item-quantity';
        quantityInfo.textContent = `${i18n.available || 'Dostępnych'} (${Math.floor(component.quantity)})`;
        priceRow.appendChild(quantityInfo);
    }

    itemContainer.appendChild(priceRow);
    container.appendChild(itemContainer);
}

function initModal() {
    modalOverlay = document.querySelector(MODAL_OVERLAY_SELECTOR);
    modal = document.querySelector(MODAL_SELECTOR);
    modalTitle = document.querySelector(MODAL_TITLE_SELECTOR);
    modalBody = document.querySelector(MODAL_BODY_SELECTOR);

    if (!modalOverlay || !modal || !modalTitle || !modalBody) {
        return;
    }

    // Load translations from data attributes
    i18n = {
        additionalCosts: modalOverlay.getAttribute('data-i18n-additional-costs') || 'Dodatkowe koszty',
        priceHistory: modalOverlay.getAttribute('data-i18n-price-history') || 'Historia ceny',
        componentPriceHistory: modalOverlay.getAttribute('data-i18n-component-price-history') || 'Historia ceny',
        downloadFiles: modalOverlay.getAttribute('data-i18n-download-files') || 'Pobierz pliki',
        required: modalOverlay.getAttribute('data-i18n-required') || 'Obowiązkowe',
        optional: modalOverlay.getAttribute('data-i18n-optional') || 'Dodatkowe',
        totalLabel: modalOverlay.getAttribute('data-i18n-total-label') || 'Cena brutto lokalu + wartość składowych obowiązkowych',
        viewHistory: modalOverlay.getAttribute('data-i18n-view-history') || 'Zobacz historię ceny',
        available: modalOverlay.getAttribute('data-i18n-available') || 'Dostępnych',
        dateColumn: modalOverlay.getAttribute('data-i18n-date-column') || 'Data zmiany ceny',
        priceColumn: modalOverlay.getAttribute('data-i18n-price-column') || 'Cena brutto',
        currency: modalOverlay.getAttribute('data-i18n-currency') || 'zł',
    };

    // Close button handler
    const closeButton = modalOverlay.querySelector(MODAL_CLOSE_SELECTOR);
    if (closeButton) {
        closeButton.addEventListener('click', closeModal);
    }

    // Overlay click handler (close when clicking outside modal)
    modalOverlay.addEventListener('click', (event) => {
        if (event.target === modalOverlay) {
            closeModal();
        }
    });

    // ESC key handler
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen) {
            closeModal();
        }
    });

    // Prevent modal from closing when clicking inside modal content
    modal.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    // Initialize triggers
    initTriggers();
}

function initTriggers() {
    const triggers = document.querySelectorAll(MODAL_TRIGGER_SELECTOR);

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            event.preventDefault();

            const modalType = trigger.getAttribute('data-modal-type');
            const modalData = trigger.getAttribute('data-modal-data');
            const apartmentName = trigger.getAttribute('data-apartment-name');

            if (modalType) {
                openModal(modalType, modalData ? JSON.parse(modalData) : null, apartmentName);
            }
        });
    });
}

function openModal(type, data = null, apartmentName = '') {
    if (!modalOverlay || !modal || !modalTitle || !modalBody) {
        return;
    }

    // Set title based on type
    const titles = {
        'additional-costs': i18n.additionalCosts || 'Dodatkowe koszty',
        'price-history': apartmentName ? `${i18n.priceHistory || 'Historia ceny lokalu'} ${apartmentName}` : (i18n.priceHistory || 'Historia ceny'),
        'component-price-history': apartmentName ? `${i18n.componentPriceHistory || 'Historia ceny'}: ${apartmentName}` : (i18n.componentPriceHistory || 'Historia ceny'),
        'download-files': i18n.downloadFiles || 'Pobierz pliki'
    };

    modalTitle.textContent = titles[type] || '';

    // Clear previous content
    modalBody.innerHTML = '';

    // Load content based on type
    loadModalContent(type, data);

    // Show modal
    modalOverlay.classList.add(MODAL_ACTIVE_CLASS);
    document.body.classList.add(MODAL_BODY_LOCK_CLASS);
    isOpen = true;

    // Focus trap - focus on close button
    const closeButton = modalOverlay.querySelector(MODAL_CLOSE_SELECTOR);
    if (closeButton) {
        closeButton.focus();
    }

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
}

function closeModal() {
    if (!modalOverlay) {
        return;
    }

    modalOverlay.classList.remove(MODAL_ACTIVE_CLASS);
    document.body.classList.remove(MODAL_BODY_LOCK_CLASS);
    isOpen = false;

    // Restore body scroll
    document.body.style.overflow = '';

    // Clear content
    if (modalBody) {
        modalBody.innerHTML = '';
    }
}

function loadModalContent(type, data) {
    if (!modalBody) {
        return;
    }

    if (type === 'download-files' && data && Array.isArray(data) && data.length > 0) {
        // Create files list container
        const filesContainer = document.createElement('div');
        filesContainer.className = 'modal__files-list';

        // Create list
        const filesList = document.createElement('div');
        filesList.className = 'modal__files-list-items';

        data.forEach((file) => {
            if (!file.url || !file.title) {
                return;
            }

            const fileItem = document.createElement('a');
            fileItem.href = file.url;
            fileItem.className = 'modal__file-item';
            fileItem.setAttribute('download', '');
            fileItem.setAttribute('target', '_blank');

            const fileText = document.createElement('span');
            fileText.className = 'modal__file-item-text';

            const fileTitle = document.createElement('span');
            fileTitle.className = 'modal__file-item-title';
            fileTitle.textContent = file.title || 'Plik';

            const fileIcon = document.createElement('span');
            fileIcon.className = 'modal__file-item-icon';
            fileIcon.innerHTML = `
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="8.08398" y1="1.83325" x2="8.08399" y2="10.4999" stroke="#191630" stroke-width="1.5"/>
                    <path d="M4.66602 7.33325L7.99935 10.6666L11.3327 7.33325" stroke="#191630" stroke-width="1.5" stroke-linecap="square"/>
                    <line x1="2.66602" y1="13.4167" x2="13.3327" y2="13.4167" stroke="#191630" stroke-width="1.5"/>
                </svg>
            `;

            fileText.appendChild(fileTitle);
            fileText.appendChild(fileIcon);
            fileItem.appendChild(fileText);
            filesList.appendChild(fileItem);
        });

        filesContainer.appendChild(filesList);
        modalBody.appendChild(filesContainer);
    } else if (type === 'additional-costs' && data && data.components) {
        // Create additional costs modal content
        const container = document.createElement('div');
        container.className = 'modal__additional-costs';

        // Separate required and optional components
        const requiredComponents = data.components.filter(c => c.isRequired);
        const optionalComponents = data.components.filter(c => !c.isRequired);

        // Two column layout
        const columnsContainer = document.createElement('div');
        columnsContainer.className = 'modal__two-columns';

        // Left column - Required (Obowiązkowe)
        const leftColumn = document.createElement('div');
        leftColumn.className = 'modal__column';

        // Left column header
        const leftHeader = document.createElement('h3');
        leftHeader.className = 'modal__section-title';
        leftHeader.textContent = i18n.required || 'Obowiązkowe';
        leftColumn.appendChild(leftHeader);

        // Left column items container
        const leftItems = document.createElement('div');
        leftItems.className = 'modal__additional-costs-items';

        // Render required components
        requiredComponents.forEach((component, index) => {
            renderComponentItem(leftItems, component, index < requiredComponents.length - 1);
        });

        leftColumn.appendChild(leftItems);

        // Total price section (in left column)
        if (data.totalRequiredPrice) {
            const totalSection = document.createElement('div');
            totalSection.className = 'modal__additional-costs-total';

            const totalLabel = document.createElement('div');
            totalLabel.className = 'modal__additional-costs-total-label';
            totalLabel.textContent = i18n.totalLabel || 'Cena brutto lokalu + wartość składowych obowiązkowych';
            totalSection.appendChild(totalLabel);

            const totalValue = document.createElement('div');
            totalValue.className = 'modal__additional-costs-total-value';
            totalValue.textContent = formatPrice(data.totalRequiredPrice) + ' ' + (i18n.currency || 'zł');
            totalSection.appendChild(totalValue);

            leftColumn.appendChild(totalSection);
        }

        columnsContainer.appendChild(leftColumn);

        // Right column - Optional (Dodatkowe)
        if (optionalComponents.length > 0) {
            const rightColumn = document.createElement('div');
            rightColumn.className = 'modal__column';

            // Right column header
            const rightHeader = document.createElement('h3');
            rightHeader.className = 'modal__section-title';
            rightHeader.textContent = i18n.optional || 'Dodatkowe';
            rightColumn.appendChild(rightHeader);

            // Right column items container
            const rightItems = document.createElement('div');
            rightItems.className = 'modal__additional-costs-items';

            // Render optional components
            optionalComponents.forEach((component, index) => {
                renderComponentItem(rightItems, component, index < optionalComponents.length - 1);
            });

            rightColumn.appendChild(rightItems);
            columnsContainer.appendChild(rightColumn);
        }

        container.appendChild(columnsContainer);
        modalBody.appendChild(container);

    } else if ((type === 'price-history' || type === 'component-price-history') && data && Array.isArray(data) && data.length > 0) {
        // Create price history container
        const historyContainer = document.createElement('div');
        historyContainer.className = 'modal__price-history';

        // Create header row
        const headerRow = document.createElement('div');
        headerRow.className = 'modal__price-history-header';

        const dateHeader = document.createElement('div');
        dateHeader.className = 'modal__price-history-header-date';
        dateHeader.textContent = i18n.dateColumn || 'Data zmiany ceny';

        const priceHeader = document.createElement('div');
        priceHeader.className = 'modal__price-history-header-price';
        priceHeader.textContent = i18n.priceColumn || 'Cena brutto';

        headerRow.appendChild(dateHeader);
        headerRow.appendChild(priceHeader);
        historyContainer.appendChild(headerRow);

        // Create divider
        const headerDivider = document.createElement('div');
        headerDivider.className = 'modal__price-history-divider';
        historyContainer.appendChild(headerDivider);

        // Create rows
        data.forEach((history, index) => {
            // Row
            const row = document.createElement('div');
            row.className = 'modal__price-history-row';

            // Date
            const dateCell = document.createElement('div');
            dateCell.className = 'modal__price-history-row-date';
            const date = new Date(history.date);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            dateCell.textContent = `${day}.${month}.${year}`;

            // Price (with price per m² in parentheses)
            const priceCell = document.createElement('div');
            priceCell.className = 'modal__price-history-row-price';

            if (history.priceGross !== null || history.pricePerM2Gross !== null) {
                const priceWrapper = document.createElement('div');
                priceWrapper.className = 'modal__price-history-row-price-wrapper';

                if (history.priceGross !== null) {
                    const formattedPrice = history.priceGross.toFixed(2).replace('.', ',');
                    const parts = formattedPrice.split(',');
                    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    const priceMain = document.createElement('span');
                    priceMain.className = 'modal__price-history-row-price-main';
                    priceMain.textContent = integerPart + ',' + parts[1] + ' ' + (i18n.currency || 'zł');
                    priceWrapper.appendChild(priceMain);
                }

                if (history.pricePerM2Gross !== null) {
                    const formattedPricePerM2 = history.pricePerM2Gross.toFixed(2).replace('.', ',');
                    const partsPerM2 = formattedPricePerM2.split(',');
                    const integerPartPerM2 = partsPerM2[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    const pricePerM2 = document.createElement('span');
                    pricePerM2.className = 'modal__price-history-row-price-per-m2';
                    pricePerM2.textContent = ` (${integerPartPerM2},${partsPerM2[1]} ${i18n.currency || 'zł'}/m²)`;
                    priceWrapper.appendChild(pricePerM2);
                }

                priceCell.appendChild(priceWrapper);
            } else {
                priceCell.textContent = '-';
            }

            row.appendChild(dateCell);
            row.appendChild(priceCell);
            historyContainer.appendChild(row);

            // Divider after each row (except last)
            if (index < data.length - 1) {
                const divider = document.createElement('div');
                divider.className = 'modal__price-history-divider';
                historyContainer.appendChild(divider);
            }
        });

        modalBody.appendChild(historyContainer);
    } else {
        // Placeholder content for other modal types
        const placeholder = document.createElement('div');
        placeholder.className = 'modal__content-placeholder';
        placeholder.innerHTML = `<p>Zawartość modala dla: ${type}</p>`;

        modalBody.appendChild(placeholder);
    }
}

function init() {
    initModal();
}

export default init;

